import React, { useEffect, useRef, useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Contact = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setTimeout(() => {
              setVisibleCards(prev => [...new Set([...prev, index])]);
            }, index * 150);
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = sectionRef.current?.querySelectorAll('[data-index]');
    cards?.forEach((card) => observer.observe(card));

    return () => {
      cards?.forEach((card) => observer.unobserve(card));
    };
  }, []);

  const contactItems = [
    {
      icon: Phone,
      title: 'Telefon',
      info: 'Anfragen gerne per Mail',
      color: '#dc2626'
    },
    {
      icon: Mail,
      title: 'Email',
      info: 'leinenluder@web.de',
      link: 'mailto:leinenluder@web.de?subject=Anfrage%20über%20Website&body=Hallo%20Leinenluder-Team,%0D%0A%0D%0A',
      color: '#dc2626'
    },
    {
      icon: MapPin,
      title: 'Adresse',
      info: '75334 Straubenhardt, Kernstrasse 2',
      color: '#dc2626'
    }
  ];

  return (
    <section 
      id="contact" 
      className="py-32 px-8 bg-zinc-800 min-h-screen flex items-center max-md:py-20 max-md:px-6" 
      ref={sectionRef}
    >
      <div className="max-w-[1400px] mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="font-display text-[3.5rem] font-bold text-white tracking-tighter leading-tight mb-4 max-md:text-[2.5rem]">
            Contact <span className="text-crimson">Info</span>
          </h2>
          <p className="font-sans text-[1.05rem] text-zinc-300 font-normal tracking-tight leading-[1.7] mb-8">
            Lass uns in Kontakt treten
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-12 max-md:gap-8">
          {contactItems.map((item, index) => {
            const IconComponent = item.icon;
            const CardWrapper = item.link ? 'a' : 'div';
            const cardProps = item.link 
              ? { 
                  href: item.link, 
                  className: `group block bg-zinc-700 p-10 px-8 text-center relative overflow-hidden border border-zinc-600 rounded-xl transition-all duration-600 ease-[cubic-bezier(0.16,1,0.3,1)] hover:border-crimson hover:shadow-[0_10px_40px_rgba(220,38,38,0.3)] hover:-translate-y-1 no-underline cursor-pointer ${visibleCards.includes(index) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[30px]'}`,
                  'data-index': index 
                }
              : { 
                  className: `group block bg-zinc-700 p-10 px-8 text-center relative overflow-hidden border border-zinc-600 rounded-xl transition-all duration-600 ease-[cubic-bezier(0.16,1,0.3,1)] hover:border-crimson hover:shadow-[0_10px_40px_rgba(220,38,38,0.3)] hover:-translate-y-1 ${visibleCards.includes(index) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[30px]'}`,
                  'data-index': index 
                };
            
            return (
              <CardWrapper
                key={index}
                {...cardProps}
              >
                <div 
                  className="mb-6 inline-flex items-center justify-center transition-transform duration-400 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.15] group-hover:-rotate-[5deg]" 
                  style={{ color: item.color }}
                >
                  <IconComponent size={64} strokeWidth={1.5} />
                </div>
                <h3 className="font-sans text-[1.4rem] text-white font-bold mb-4 tracking-tight">
                  {item.title}
                </h3>
                <p className={`font-sans text-base font-normal leading-[1.7] tracking-tight ${
                  item.link 
                    ? 'text-crimson font-semibold group-hover:text-red-500' 
                    : 'text-zinc-300'
                }`}>
                  {item.info}
                </p>
              </CardWrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Contact;

